<template>
<div :ref="loadingobj">
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">{{ pageTitle }}</span>
        <div class="TTL-button TTL-btn-option">
            <wcbutton :option="{title:'保存设置'}" @finish="SubmitAuth" />
        </div>
        <div class="TTL-button TTL-btn-option">
            <wcbutton :option="{title:'返回版本管理',type:'del'}" @finish="GoBack(false)" />
        </div>
    </div>

    <div class="TTL-form-submit-box">
        <div class="permission-tree" v-if="rootMenu">
            <div class="select-all-wrapper">
                <el-checkbox
                    v-model="rootMenu.isselect"
                    :indeterminate="!!rootMenu.isselectAll"
                    @click.stop.prevent="selectLabel(rootMenu, '0')"
                >
                    <span class="select-all-text">全选</span>
                </el-checkbox>
            </div>

            <div class="tree-level-1" v-for="(level1, index1) in rootChildren" :key="'l1-'+level1.id+'-'+index1">
                <div class="level-1-header">
                    <el-checkbox
                        v-model="level1.isselect"
                        :indeterminate="!!level1.isselectAll"
                        @click.stop.prevent="selectLabel(level1, '0-'+index1)"
                    >
                        <span class="level-1-name">{{ level1.name }}<i v-if="isPaid(level1)">（收费功能）</i></span>
                    </el-checkbox>
                </div>

                <div class="tree-level-2-wrapper" v-if="level1.children && level1.children.length">
                    <div class="tree-level-2" v-for="(level2, index2) in level1.children" :key="'l2-'+level2.id+'-'+index2">
                        <div class="level-2-header">
                            <el-checkbox
                                v-model="level2.isselect"
                                :indeterminate="!!level2.isselectAll"
                                @click.stop.prevent="selectLabel(level2, '0-'+index1+'-'+index2)"
                            >
                                <span class="level-2-name">{{ level2.name }}<i v-if="isPaid(level2)">（收费功能）</i></span>
                            </el-checkbox>
                        </div>

                        <div class="tree-level-3" v-if="level2.children && level2.children.length">
                            <div class="level-3-item" v-for="(level3, index3) in level2.children" :key="'l3-'+level3.id+'-'+index3">
                                <el-checkbox
                                    v-model="level3.isselect"
                                    :indeterminate="!!level3.isselectAll"
                                    @click.stop.prevent="selectLabel(level3, '0-'+index1+'-'+index2+'-'+index3)"
                                >
                                    {{ level3.name }}<i v-if="isPaid(level3)">（收费功能）</i>
                                </el-checkbox>
                                <div class="tree-level-4" v-if="level3.children && level3.children.length">
                                    <el-checkbox
                                        v-for="(level4, index4) in level3.children"
                                        :key="'l4-'+level4.id+'-'+index4"
                                        v-model="level4.isselect"
                                        :indeterminate="!!level4.isselectAll"
                                        @click.stop.prevent="selectLabel(level4, '0-'+index1+'-'+index2+'-'+index3+'-'+index4)"
                                    >
                                        {{ level4.name }}<i v-if="isPaid(level4)">（收费功能）</i>
                                    </el-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-empty v-else description="暂无权限数据" />
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/index';
export default {
    name: 'SetPlatFormLevelAuth',
    data() {
        return {
            loadingobj: 'setplatlevelauth',
            levelid: '',
            levelname: '',
            menus: [],
            selectids: [],
        };
    },
    computed: {
        rootMenu() {
            return this.menus && this.menus.length ? this.menus[0] : null;
        },
        rootChildren() {
            return this.rootMenu && Array.isArray(this.rootMenu.children) ? this.rootMenu.children : [];
        },
        pageTitle() {
            return this.levelname ? `设置权限 - ${this.levelname}` : '设置权限';
        },
    },
    mounted() {
        this.OnloadMethod();
    },
    methods: {
        OnloadMethod() {
            if (this.levelid) this.GetLevelAuth(this.levelid);
        },
        BrotherComponentIn(data) {
            const payload = data && data.param ? data.param : data;
            const id = payload && payload.id ? payload.id : '';
            const levelname = payload && payload.levelname ? payload.levelname : '';
            if (data && data.isask && this.levelid && String(this.levelid) !== String(id)) {
                this.$confirm
                    .confirm('当前有权限设置正在编辑，是否覆盖？', '操作提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                    })
                    .then(() => {
                        this.levelid = id;
                        this.levelname = levelname;
                        this.GetLevelAuth(id);
                    })
                    .catch(() => {});
                return;
            }
            this.levelid = id;
            this.levelname = levelname;
            this.GetLevelAuth(id);
        },
        isPaid(item) {
            return item && (item.isfree == 1 || item.isfree == 2);
        },
        ensureChildren(list) {
            if (!Array.isArray(list)) return;
            list.forEach((node) => {
                if (!Array.isArray(node.children)) node.children = [];
                if (node.isselectAll === undefined) node.isselectAll = false;
                this.ensureChildren(node.children);
            });
        },
        GetLevelAuth(id) {
            if (!id) return;
            const obj = this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_SHOP.GET_LEVEL_AUTH({ id }).then((res) => {
                this.$loading.closeloading(obj);
                if (res.status > 0) return false;
                this.menus = res.data || [];
                this.ensureChildren(this.menus);
                this.resetLable(this.menus);
            });
        },
        SubmitAuth() {
            this.selectids = [];
            this.GetSelectIds();
            if (this.selectids.length == 0) {
                this.$notice({ title: '错误提示', message: '请至少选择一个权限', type: 'warning' });
                return false;
            }
            const obj = this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_SHOP.UPDATE_LEVEL_AUTH({
                id: this.levelid,
                data: this.selectids.join(','),
            }).then((res) => {
                this.$loading.closeloading(obj);
                if (res.status > 0) return false;
                this.$notice({ title: '成功提示', message: '权限设置保存成功', type: 'success' });
                this.GoBack(true);
            });
        },
        GoBack(isdellocal) {
            this.$parent.JUMPVIEW({
                name: 'PlatFormLevel',
                delname: isdellocal ? 'SetPlatFormLevelAuth' : '',
            });
        },
        target(item) {
            item.isshow ? (item.isshow = false) : (item.isshow = true);
        },
        selectLabel(item, treeindex) {
            item.isselectAll = false;
            item.isselect && item.isselect == true ? (item.isselect = false) : (item.isselect = true);
            this.changeChildLabel(item.children, item.isselect);
            this.changeParentLable(treeindex);
        },
        changeParentLable(treeindex) {
            if (treeindex == 0) return false;
            treeindex = treeindex.split('-');
            var nums = treeindex.length - 1;
            if (nums == 0) return '';
            var obj;
            var childisselect = 0;
            nums -= 1;
            for (var i = 0; i < treeindex.length; i++) {
                if (nums < 0) return false;
                obj = this.GetTreeObj(treeindex, nums, this.menus);
                obj.isselect = false;
                obj.isselectAll = false;
                childisselect = this.checkchildisselect(obj.children);
                if (childisselect == 1) {
                    obj.isselect = true;
                    obj.isselectAll = false;
                }
                if (childisselect == 2) {
                    obj.isselect = true;
                    obj.isselectAll = true;
                }
                nums--;
            }
        },
        GetTreeObj(treeindex, nums, obj) {
            var obji;
            for (var i = 0; i < treeindex.length; i++) {
                if (i > nums) return obj;
                obji = treeindex[i];
                i == 0 ? (obj = obj[obji]) : (obj = obj.children[obji]);
            }
            return obj;
        },
        changeChildLabel(data, isselect) {
            if (!data || !data.length) return;
            var obj;
            var children;
            for (var i = 0; i < data.length; i++) {
                obj = data[i];
                children = obj.children;
                obj.isselect = isselect;
                obj.isselectAll = false;
                if (children && children.length > 0) this.changeChildLabel(children, isselect);
            }
        },
        resetLable(data) {
            var obj;
            var children;
            var childisselect = 0;
            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    obj = data[i];
                    children = obj.children;
                    if (children && children.length > 0) {
                        obj.isselect = false;
                        obj.isselectAll = false;
                        childisselect = this.checkchildisselect(children);
                        if (childisselect == 1) {
                            obj.isselect = true;
                            obj.isselectAll = false;
                        }
                        if (childisselect == 2) {
                            obj.isselect = true;
                            obj.isselectAll = true;
                        }
                        this.resetLable(children);
                    }
                }
            }
        },
        checkchildisselect(data) {
            var isselectAll = 0;
            var datainfo;
            if (!data || !data.length) return 0;
            for (var i = 0; i < data.length; i++) {
                datainfo = data[i];
                if (datainfo.isselectAll) return 2;
                if (i > 0 && datainfo.isselect != isselectAll) return 2;
                datainfo.isselect ? (isselectAll = 1) : (isselectAll = 0);
            }
            return isselectAll;
        },
        GetSelectIds() {
            this.GetSelectIdsData(this.menus);
        },
        GetSelectIdsData(obj) {
            var objinfo;
            for (var i = 0; i < obj.length; i++) {
                objinfo = obj[i];
                if (objinfo.isselect && objinfo.id > 0) this.selectids.push(objinfo.id);
                if (objinfo.children && objinfo.children.length > 0) this.GetSelectIdsData(objinfo.children);
            }
        },
    },
};
</script>
<style scoped>
.TTL-btn-option {
    display: inline-block;
    margin-right: 20px;
}
.permission-tree {
    padding: 10px 0;
}
.select-all-wrapper {
    padding: 15px 20px;
    margin-bottom: 20px;
    background: #fff;
    border: 2px solid #666eeb;
    border-radius: 4px;
}
.select-all-text {
    font-weight: bold;
    font-size: 14px;
    color: #666eeb;
}
.tree-level-1 {
    margin-bottom: 25px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    background: #fff;
}
.tree-level-1:last-child {
    margin-bottom: 0;
}
.level-1-header {
    padding: 12px 20px;
    background: #f5f7fa;
    border-bottom: 1px solid #e0e0e0;
}
.level-1-name {
    font-weight: bold;
    font-size: 14px;
    color: #333;
}
.tree-level-2-wrapper {
    padding: 15px 20px;
}
.tree-level-2 {
    margin-bottom: 15px;
    padding: 12px 15px;
    background: #fafafa;
    border-radius: 4px;
}
.tree-level-2:last-child {
    margin-bottom: 0;
}
.level-2-header {
    margin-bottom: 10px;
}
.level-2-name {
    font-weight: 600;
    font-size: 13px;
    color: #555;
}
.tree-level-3 {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 20px;
    padding-left: 24px;
}
.level-3-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.tree-level-4 {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 16px;
    padding-left: 22px;
}
.level-1-name i,
.level-2-name i,
.tree-level-3 i {
    font-style: normal;
    font-size: 12px;
    color: #e32626;
    font-weight: normal;
}
:deep(.el-checkbox) {
    align-items: center;
}
:deep(.el-checkbox__label) {
    padding-left: 8px;
}
:deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner::before) {
    top: 6px;
    height: 5px;
}
</style>
